import { render, staticRenderFns } from "./AttributeManagement.vue?vue&type=template&id=0aaba58b&scoped=true"
import script from "./AttributeManagement.vue?vue&type=script&lang=js"
export * from "./AttributeManagement.vue?vue&type=script&lang=js"
import style0 from "./AttributeManagement.vue?vue&type=style&index=0&id=0aaba58b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaba58b",
  null
  
)

export default component.exports